import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { MessageCircle, Send, X } from "lucide-react";
import { getWithTokenAPI, postWithTokenAPI } from "../util/Api";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";

import { setCurrentPage } from "../redux/navigationSlice.js";
import { useDispatch, useSelector } from "react-redux";

export function MessageModal({
  isOpen,
  onClose,
  profileid,
  profileName,
  userid,
  token,
}) {
  const [message, setMessage] = useState("");
  const [messageSent, setMessageSent] = useState(false);
  const dispatch = useDispatch();

  const [ShowSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const handleSendMessage = async () => {
    if (message.trim()) {
      // Here you would typically send the message to your backend
      // setMessageSent(true);
      // setTimeout(() => {
      //   onClose();
      //   setMessageSent(false);
      //   setMessage("");
      // }, 2000);
      const payload = {
        sender_id: userid,
        receiver_id: profileid,
        content: message,
      };
      const response = await postWithTokenAPI(token, `/message/send`, payload);
      if (response?.statusCode == 200) {
        setMessageSent(true);
        setTimeout(() => {
          onClose();
          setMessageSent(false);
          setMessage("");
        }, 2000);
      } else if (response.statusCode == 403) {
        setShowSubscribeDialog(true);
      }
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageCircle className="h-5 w-5 text-blue-500" />
            {messageSent ? "Message Sent" : "Send Message"}
          </DialogTitle>
        </DialogHeader>

        {!messageSent ? (
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Send message to {profileName}
            </p>

            <div className="space-y-2">
              <Label htmlFor="message-content">Your message *</Label>
              <Textarea
                id="message-content"
                placeholder="Type your message here"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                required
              />
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={onClose}>
                <X className="h-4 w-4 mr-2" />
                cancel
              </Button>
              <Button
                onClick={handleSendMessage}
                // disabled={!message.trim()}
                // className="bg-blue-500 hover:bg-blue-600"
              >
                <Send className="h-4 w-4 mr-2" />
                Send
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center py-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MessageCircle className="h-8 w-8 text-green-600" />
            </div>
            <p className="text-green-600 font-medium">
              Message sent succesfully
            </p>
            <p className="text-muted-foreground text-sm mt-2">
              Notification sent to {profileName}
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
  <AlertDialog open={ShowSubscribeDialog} onOpenChange={setShowSubscribeDialog}>
    <AlertDialogContent className="max-w-sm text-center">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-red-600 text-xl font-semibold">
          🔔 Subscription Required
        </AlertDialogTitle>
        <AlertDialogDescription className="text-gray-600 mt-2">
          Upgrade your plan to explore more matches
        </AlertDialogDescription>
      </AlertDialogHeader>

      <div className="flex justify-center gap-3 mt-4">
        <AlertDialogCancel
          onClick={() => setShowSubscribeDialog(false)}
          className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
        >
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg cursor-pointer"
          onClick={() => {
            setShowSubscribeDialog(false);
            dispatch(setCurrentPage("subscription"));
          }}
        >
          Subscribe Now
        </AlertDialogAction>
      </div>
    </AlertDialogContent>
  </AlertDialog>;
}
